import { useMemo, useCallback } from "react";
import debounce from "lodash/debounce";

import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import UpIcon from "@mui/icons-material/KeyboardArrowUp";
import DownIcon from "@mui/icons-material/KeyboardArrowDown";

interface EmployeeCountProps {
	allottedMinutes: number;
	setAllottedMinutes: React.Dispatch<React.SetStateAction<number>>;
	allottedOpen: boolean;
	setAllottedOpen: React.Dispatch<React.SetStateAction<boolean>>;
	handleAllottedMinutesChange: (value: number) => void;
}

export const AllottedTime = ({ allottedMinutes, setAllottedMinutes, allottedOpen, setAllottedOpen, handleAllottedMinutesChange }: EmployeeCountProps) => {
	const changeTime = useCallback(
		(value: number) => {
			handleAllottedMinutesChange(value);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const setAllottedMinutesDebounce = useMemo(() => debounce(changeTime, 1000), [changeTime]);

	const handleIncrement = () => {
		setAllottedMinutes((prevCount) => {
			let newCount = prevCount % 5 === 0 ? prevCount + 5 : prevCount + 5 - (prevCount % 5);
			setAllottedMinutesDebounce(newCount);
			return newCount;
		});
	};

	const handleDecrement = () => {
		setAllottedMinutes((prevCount) => {
			let newCount = prevCount % 5 === 0 ? (prevCount < 5 ? 0 : prevCount - 5) : prevCount - (prevCount % 5);
			setAllottedMinutesDebounce(newCount);
			return newCount;
		});
	};

	const handleIncrementHour = () => {
		setAllottedMinutes((prevCount) => {
			let newCount = Number(prevCount) + 60;
			setAllottedMinutesDebounce(newCount);
			return newCount;
		});
	};

	const handleDecrementHour = () => {
		setAllottedMinutes((prevCount) => {
			let newCount = Number(prevCount) - 60 < 0 ? 0 : Number(prevCount) - 60;
			setAllottedMinutesDebounce(newCount);
			return newCount;
		});
	};

	return (
		<Dialog
			maxWidth="xs"
			open={allottedOpen}
			onClose={() => {
				setAllottedOpen(false);
			}}
		>
			<DialogTitle>Allotted Time</DialogTitle>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={5} style={{ textAlign: "right" }}>
						<Button variant="contained" color="secondary" onClick={handleIncrementHour} className="employeeBtn">
							<UpIcon />
						</Button>
					</Grid>
					<Grid item>&nbsp;</Grid>
					<Grid item xs={5} style={{ textAlign: "left" }}>
						<Button variant="contained" color="secondary" onClick={handleIncrement} className="employeeBtn">
							<UpIcon />
						</Button>
					</Grid>

					<Grid item xs={5} style={{ textAlign: "right" }}>
						{Math.floor(allottedMinutes / 60)}
					</Grid>
					<Grid item>:</Grid>
					<Grid item xs={5} style={{ textAlign: "left" }}>
						{("00" + (allottedMinutes % 60)).slice(-2)}
					</Grid>

					<Grid item xs={5} style={{ textAlign: "right" }}>
						<Button variant="contained" color="secondary" onClick={handleDecrementHour} className="employeeBtn">
							<DownIcon />
						</Button>
					</Grid>
					<Grid item>&nbsp;</Grid>
					<Grid item xs={5} style={{ textAlign: "left" }}>
						<Button variant="contained" color="secondary" onClick={handleDecrement} className="employeeBtn">
							<DownIcon />
						</Button>
					</Grid>
				</Grid>
				<DialogActions>
					<Button onClick={() => setAllottedOpen(false)} color="primary">
						Close
					</Button>
				</DialogActions>
			</DialogContent>
		</Dialog>
	);
};

export default AllottedTime;
